export default "__VITE_ASSET__DlQ9jZs8__"